import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import WysiwygRoundedIcon from '@mui/icons-material/WysiwygRounded';
import { Box, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { colors } from '~/theme';

export const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = location.pathname.startsWith('/dicas') ? '/dicas' : '/onboarding';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <BottomNavigation
        value={currentTab}
        onChange={(_, value) => navigate(value)}
        showLabels
        sx={{
          backgroundColor: colors.trueCobalt,
          '& .MuiBottomNavigationAction-root': { color: colors.white },
          '& .MuiBottomNavigationAction-root.Mui-selected': { color: `${colors.white} !important` },
        }}
      >
        <BottomNavigationAction label="Seleção" value="/onboarding" icon={<RuleRoundedIcon />} />
        <BottomNavigationAction label="Dicas" value="/dicas" icon={<WysiwygRoundedIcon />} />
      </BottomNavigation>
    </Box>
  );
};
